import React from "react";
import { Empty } from "antd";
import Typography from "../Typography/Typography";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import "./EmptyTableScreen.scss";

const EmptyTableScreen = ({ icon, header, content, isActionButton, actionButtonContent, actionButtonHandler }) => {
  return (
    <Empty
      image={icon}
      imageStyle={{
        height: 70,
      }}
      description={
        <div>
          <Typography h4 className="empty-table-header">
            {header}
          </Typography>
          <div className="empty-table-content">{content}</div>
        </div>
      }
    >
      {isActionButton && <PrimaryButton label={actionButtonContent} onClick={actionButtonHandler} />}
    </Empty>
  );
};

export default EmptyTableScreen;
